import { Send16Regular, SineWaveDots20Filled, Stop16Filled } from '@/components/Icon'

/**
 * The four states of the composer's one primary control.
 *
 * `tone` picks the fill: `brand` is the DO gradient, `ink` is flat #2B2B2B.
 * Stopping a reply is deliberately not brand-coloured — it interrupts rather
 * than initiates, and the frames draw it as plain ink.
 */
export const SPEAK_MODES = {
  speak: { label: 'Speak', aria: 'Start voice mode', Icon: SineWaveDots20Filled, tone: 'brand', size: 'pill' },
  send: { label: null, aria: 'Send', Icon: Send16Regular, tone: 'brand', size: 'circle' },
  stopVoice: { label: 'Stop', aria: 'Stop voice mode', Icon: SineWaveDots20Filled, tone: 'ink', size: 'pill' },
  stopStream: { label: null, aria: 'Stop generating', Icon: Stop16Filled, tone: 'ink', size: 'circle' },
}
